var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-date-picker',{attrs:{"format":_vm.$dateFormat,"type":"date","size":_vm.size,"placeholder":_vm.placeholder,"picker-options":_vm.pickerOptions},on:{"change":_vm.emitDate},model:{value:(_vm.selectedDateUpdate),callback:function ($$v) {_vm.selectedDateUpdate=$$v},expression:"selectedDateUpdate"}})
}
var staticRenderFns = []

export { render, staticRenderFns }